import React, { useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  List,
  ListItemButton,
  ListItemText,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useNavigate } from 'react-router-dom';
import newCategories from './categories';

const CATALOGUE_ID = '64ef4986d269731b208134bf';
const CATALOGUE_BASE = `/market/categoria/${CATALOGUE_ID}?nombre=MARKET`;

function buildQueryFromFilter(filter = {}) {
  const sp = new URLSearchParams();
  if (filter.Categoria) sp.set('cat', filter.Categoria);
  if (filter.Subcategoria) sp.set('subcat', filter.Subcategoria);
  if (filter.Marca) sp.set('marca', filter.Marca);
  if (filter.Termino) sp.set('q', filter.Termino);
  const qs = sp.toString();
  return qs ? `${CATALOGUE_BASE}&${qs}` : CATALOGUE_BASE;
}

const MegaMenuMobile = ({ isCatalogue, expandedNav, setExpandedNav }) => {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);

  const goCatalogue = (filter) => {
    const url = buildQueryFromFilter(filter);
    if (isCatalogue) setExpandedNav?.(false);
    navigate(url);
  };

  const handleNavigateCatalogue = (filter) => {
    if (filter?.Categoria && /ganga/i.test(filter.Categoria)) {
      if (isCatalogue) setExpandedNav?.(false);
      navigate('/ofertas');
    } else {
      goCatalogue(filter);
    }
  };

  const handleAccordionClick = (panel, title) => (event, isExpanded) => {
    if (/ganga/i.test(title)) {
      event.stopPropagation();
      if (isCatalogue) setExpandedNav?.(false);
      navigate('/ofertas');
    } else {
      setExpanded(isExpanded ? panel : false);
    }
  };

  return (
    <div>
      {newCategories.map((section, index) => (
        <Accordion
          key={index}
          sx={{
            boxShadow: 'none',
            borderBottom: '1px solid #ddd',
            '&:before': { display: 'none' },
          }}
          expanded={expanded === `panel-${index}`}
          onChange={handleAccordionClick(`panel-${index}`, section.title)}
        >
          <AccordionSummary
            sx={{
              backgroundColor:
                expanded === `panel-${index}` ? '#23563f32' : 'transparent',
              transition: 'background-color 0.3s ease',
            }}
            expandIcon={<ExpandMoreIcon />}
          >
            <Typography sx={{ fontFamily: 'Poppins', fontWeight: 400 }} variant="subtitle1">
              {section.title}
            </Typography>
          </AccordionSummary>

          {!/ganga/i.test(section.title) && (
            <AccordionDetails style={{ maxHeight: '250px', overflowY: 'auto' }}>
              <List disablePadding>
                {section.categories?.map((category, idx) => (
                  <div key={idx}>
                    <ListItemButton onClick={() => handleNavigateCatalogue(category.filter)}>
                      <ListItemText
                        primary={<Typography sx={{ fontWeight: 600 }}>{category.name}</Typography>}
                      />
                    </ListItemButton>

                    {category.subcategories?.map((sub, subIdx) => (
                      <ListItemButton
                        key={subIdx}
                        sx={{ pl: 4 }}
                        onClick={() => handleNavigateCatalogue(sub.filter)}
                      >
                        <ListItemText primary={sub.label} />
                      </ListItemButton>
                    ))}
                  </div>
                ))}

                {section.marcasArray?.length > 0 && (
                  <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                    {section.marcasArray.map((marca, marcaIdx) => (
                      <ListItemButton
                        key={marcaIdx}
                        onClick={() => goCatalogue({ Marca: marca })}
                      >
                        <ListItemText primary={marca} />
                      </ListItemButton>
                    ))}
                  </div>
                )}
              </List>
            </AccordionDetails>
          )}
        </Accordion>
      ))}
    </div>
  );
};

export default MegaMenuMobile;
